import { Elements } from "@stripe/react-stripe-js";
import { StripeElementsOptions, loadStripe } from "@stripe/stripe-js";
import axios from "axios";
import classNames from "classnames";
import React, { Suspense, useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import whitelabel from "./utils/whitelabel";
import Whitelabel from "./models/enums/Whitelabel";
import { jwtDecode } from "jwt-decode";

declare global {
    interface Window {
        $zoho: any;
    }
}

const loading = (
    <div className="pt-3 text-center">
        <div className="sk-spinner sk-spinner-pulse"></div>
    </div>
);

const Home = React.lazy(() => import("./containers/Home/Home"));
const Charge = React.lazy(() => import("./containers/Charge/ChargeStart"));
const ConnectorSelection = React.lazy(() => import("./containers/Charge/ConnectorSelection"));
const Phone = React.lazy(() => import("./containers/Charge/SubmitPhone"));
const Payment = React.lazy(() => import("./containers/Charge/PaymentDetails"));
const SessionStarted = React.lazy(
    () => import("./containers/Charge/SessionStarted"),
);
const SessionPage = React.lazy(
    () => import("./containers/SessionPage/SessionPage"),
);
const UnavailableStation = React.lazy(
    () => import("./containers/Charge/UnavailableStation"),
);
const UserOffline = React.lazy(() => import("./containers/Charge/UserOffline"));
const StartRedirect = React.lazy(
    () => import("./containers/Charge/StartRedirect"),
);
const stripePublishableKey =
    process.env.REACT_APP_STRIPE_PUB_KEY ?? "missing stripe key";
const stripePromise = loadStripe(stripePublishableKey);

export default function App() {
    const qrCode = window.location.pathname.split("/")[2];
    const [jwt, setJwt] = useState<string | null>(
        localStorage.getItem("otc-token"),
    );

    useEffect(() => {
        if(jwt != null && jwt != undefined && jwt != "") {
            const decoded = jwtDecode(jwt);
            if(decoded && decoded.exp && (decoded.exp < Date.now() / 1000)) {
                localStorage.removeItem("otc-token");
                axios
                .post(`${process.env.REACT_APP_AUTH_ENDPOINT}/mobile/token`)
                .then((result) => {
                    localStorage.setItem("otc-token", result.data.access_token);
                    setJwt(result.data.access_token);
                    if (qrCode) localStorage.setItem("otc-qrCode", qrCode);
                });
            }
        } else {
            axios
            .post(`${process.env.REACT_APP_AUTH_ENDPOINT}/mobile/token`)
            .then((result) => {
                localStorage.setItem("otc-token", result.data.access_token);
                setJwt(result.data.access_token);
                if (qrCode) localStorage.setItem("otc-qrCode", qrCode);
            });
        }


        if(whitelabel === Whitelabel.OCVIBE) {
            window.$zoho = {};
            window.$zoho.salesiq = {
                widgetcode:
                    "cfe5a9133dd85207259d99e85044c2960319418500c5bd76803cbd17f80c23c1",
                values: {},
                ready: function () {
                    window.$zoho.salesiq.visitor.email("");
                },
            };
            const d = document;
            let s;
            s = d.createElement("script");
            s.type = "text/javascript";
            s.id = "zsiqscript";
            s.defer = true;
            s.src = "https://salesiq.zoho.com/widget";
            let t;
            t = d.getElementsByTagName("script")[0];
            if (t.parentNode) t.parentNode.insertBefore(s, t);
            if (window.$zoho.salesiq.floatbutton)
                window.$zoho.salesiq.floatbutton.visible("show");
            return () => {
                if (window.$zoho.salesiq && window.$zoho.salesiq.visitor) {
                    window.$zoho.salesiq.visitor.email("");
                    window.$zoho.salesiq.reset();
                }
            };
        }
    }, [qrCode]);

    const appearance = {
        theme: "stripe",
    };
    const options: StripeElementsOptions = {
        mode: "setup",
        currency: "usd",
        paymentMethodCreation: "manual",
    };

    if (!jwt) return null;

    return (
        <div
            className={classNames(
                "App",
                process.env.REACT_APP_WHITELABEL &&
                    `App--${process.env.REACT_APP_WHITELABEL}`,
            )}
        >
            <Suspense fallback={loading}>
                <Elements options={options} stripe={stripePromise}>
                    <Routes>
                        <Route path="*" element={<Home />} />
                        <Route
                            path="/station/:chargieId/*"
                            element={<Charge />}
                        />
                        <Route path="/connector" element={<ConnectorSelection />} />
                        <Route path="/phone" element={<Phone />} />
                        <Route path="/payment" element={<Payment />} />
                        <Route
                            path="/session-started"
                            element={<SessionStarted />}
                        />
                        <Route
                            path="/session/:sessionId"
                            element={<SessionPage />}
                        />
                        <Route
                            path="/session/:sessionId/:chargieId"
                            element={<SessionPage />}
                        />
                        <Route
                            path="/unavailable"
                            element={<UnavailableStation />}
                        />
                        <Route path="/user-offline" element={<UserOffline />} />
                        <Route
                            path="/startRedirect"
                            element={<StartRedirect />}
                        />
                    </Routes>
                </Elements>
            </Suspense>
        </div>
    );
}
